import create from 'zustand';
import {IUser} from "../api/User/User.types";


const useUserStore = create<AppStoreState>(set => ({
    authToken: undefined,
    authTokenChecked: false,
    user: undefined,
    loadingUser: false,


    setLoadingUser: loadingUser => set({loadingUser}),
    setUser: user => set({user})
}))

interface AppStoreState {
    authToken: string
    authTokenChecked: boolean
    user: IUser
    loadingUser: boolean


    setLoadingUser: (loadingUser) => void
    setUser: (user: IUser) => void
}

export default useUserStore;